// extracted by mini-css-extract-plugin
export default {"row":"AddressRow_row__d1n5h","icon":"AddressRow_icon__8rt9-","mapLink":"AddressRow_mapLink__I58hp","address":"AddressRow_address__is-0l","secondRow":"AddressRow_secondRow__W-SYM"};